import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Choose the subscriptions you need: ", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, " Maths - £10 per year ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Spelling - £10 per year "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Access all spelling games and activities, practise National Curriculum spelling rules and create personalised word lists. ")
], -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, " Maths worksheets - £10 per year ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "All three subcriptions - £25 per year", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " All prices include VAT. ", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, " Create individual logins for every child in your class. Set differentiated tasks and monitor pupils' scores and progress. ", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, " Maths - £30 + VAT per class, per year ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Spelling - £30 + VAT per class, per year "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Create differentiated word lists and give pupils personalised spelling practice with spoken words, example sentences and immediate feedback. ")
], -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", null, " Maths and spelling together - £50 + VAT per class, per year ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.products)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.type == 'individual')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.mathsAvailable)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                    _hoisted_5,
                    _hoisted_6,
                    _createTextVNode(" Access more than 300 maths games and curriculum-aligned activities. Practise key skills, receive instant animated feedback and track your progress. ")
                  ]))
                : _createCommentVNode("", true),
              _hoisted_7,
              (_ctx.mathsAvailable)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createTextVNode(" Access printable worksheets and assessments, organised by year group and curriculum topic. ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.mathsAvailable)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true),
              _hoisted_14
            ]))
          : (_ctx.type == 'school')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                (_ctx.mathsAvailable)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                      _hoisted_18,
                      _hoisted_19,
                      _createTextVNode(" Access all maths games, interactive questions and teaching tools, plus printable maths worksheets. ")
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_20,
                (_ctx.mathsAvailable)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      _createTextVNode(" Students and teachers can access all resources with a single username and password and can move between maths and spelling tasks without logging out. ")
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}